

































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SearchTextField",
  props: {
    id: {
      type: String as PropType<Props["id"]>,
      default: ""
    },
    invalid: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    focus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    gaEventCategory: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    invalidClass: function() {
      return {
        "searchTextField__input--invalid": this.invalid
      };
    },
    disabledClass: function() {
      return {
        "searchTextField__input--disabled": this.disabled
      };
    }
  },
  mounted() {
    if (this.focus) {
      const $input = this.$refs.input as HTMLElement;
      $input.focus();
    }
  },
  methods: {
    updateValue(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        sendGaEvent(this, {
          gaEventType: "change",
          gaEventCategory: this.$props.gaEventCategory,
          gaEventLabel: {
            value: event.target.value
          }
        });
        this.$emit("input", event.target.value);
        this.$emit("change", event.target.value);
      }
    },
    onClickClear(event: Event) {
      sendGaEvent(this, {
        gaEventCategory: `${this.gaEventCategory}_入力内容をリセット`
      });
      this.$emit("click", event);
    }
  }
});
